/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnamount3Inputs */

const en_ticketpagecolumnamount3 = /** @type {(inputs: Ticketpagecolumnamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const de_ticketpagecolumnamount3 = /** @type {(inputs: Ticketpagecolumnamount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrag`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Ticketpagecolumnamount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnamount3 = /** @type {((inputs?: Ticketpagecolumnamount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnamount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnamount3(inputs)
	return de_ticketpagecolumnamount3(inputs)
});
export { ticketpagecolumnamount3 as "ticketPageColumnAmount" }